import type { Distribution } from "@solomon-apps/shared";
import { BigDecimal } from "@solomon-labs/bigdecimal";

import type { UsdvSwap } from "./usdvSwaps";

export interface HistoryEntry {
    id: string;
    timestamp: number;
    kind: "buy" | "sell" | "distribution";
    signature: string | null;
    amount: BigDecimal;
    otherToken?: UsdvSwap["otherToken"];
    balance?: BigDecimal;
}

/** Keep source-specific identities: one signature may contain distinct reward events. */
export function mergeHistory(swaps: UsdvSwap[], distributions: Distribution[], cutoff = -Infinity): HistoryEntry[] {
    const entries: HistoryEntry[] = [
        ...swaps.map(
            (swap): HistoryEntry => ({
                id: `swap:${swap.signature}`,
                timestamp: swap.timestamp,
                kind: swap.type,
                signature: swap.signature,
                amount: swap.usdvAmount,
                otherToken: swap.otherToken
            })
        ),
        ...distributions.map(
            (distribution): HistoryEntry => ({
                id: `distribution:${distribution.id}`,
                timestamp: Date.parse(distribution.distributionDate) / 1000 || 0,
                kind: "distribution",
                signature: distribution.transactionId,
                amount: new BigDecimal(distribution.amount),
                balance:
                    distribution.balanceAtDistribution === null
                        ? undefined
                        : new BigDecimal(distribution.balanceAtDistribution)
            })
        )
    ];
    return [...new Map(entries.map((entry) => [entry.id, entry])).values()]
        .filter((entry) => entry.timestamp >= cutoff)
        .sort((a, b) => b.timestamp - a.timestamp || a.id.localeCompare(b.id));
}
